(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kova-disclaimer"] && !Shopify.designMode) return;
  try {
    
(function(){
  var sections = document.querySelectorAll('.kp-section[id]');
  var tocLinks = document.querySelectorAll('.kp-toc-list a');
  if(!sections.length || !tocLinks.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        tocLinks.forEach(function(l){l.classList.remove('kp-toc-active')});
        var a = document.querySelector('.kp-toc-list a[href="#'+e.target.id+'"]');
        if(a) a.classList.add('kp-toc-active');
      }
    });
  },{rootMargin:'-20% 0px -70% 0px'});
  sections.forEach(function(s){io.observe(s)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-footer"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Sticky bar — hide once user scrolls far enough up from bottom
  var sticky = document.getElementById('kfSticky');
  if (!sticky) return;

  var lastScroll = 0;
  var ticking = false;

  function updateSticky() {
    var scrollY = window.scrollY || window.pageYOffset;
    var winH = window.innerHeight;
    var docH = document.documentElement.scrollHeight;
    // Show sticky when NOT at the very bottom (near footer)
    var nearBottom = scrollY + winH > docH - 200;
    if (nearBottom) {
      sticky.style.transform = 'translateY(100%)';
      sticky.style.opacity = '0';
    } else if (scrollY > 300) {
      sticky.style.transform = 'translateY(0)';
      sticky.style.opacity = '1';
    } else {
      sticky.style.transform = 'translateY(100%)';
      sticky.style.opacity = '0';
    }
    lastScroll = scrollY;
    ticking = false;
  }

  sticky.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
  sticky.style.transform = 'translateY(100%)';
  sticky.style.opacity = '0';

  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(updateSticky);
      ticking = true;
    }
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-policy-cookie"] && !Shopify.designMode) return;
  try {
    

(function(){
  var sections = document.querySelectorAll('.kp-section[id]');
  var tocLinks = document.querySelectorAll('.kp-toc-list a');
  if(!sections.length || !tocLinks.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        tocLinks.forEach(function(l){l.classList.remove('kp-toc-active')});
        var a = document.querySelector('.kp-toc-list a[href="#'+e.target.id+'"]');
        if(a) a.classList.add('kp-toc-active');
      }
    });
  },{rootMargin:'-20% 0px -70% 0px'});
  sections.forEach(function(s){io.observe(s)});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-policy-impressum"] && !Shopify.designMode) return;
  try {
    

(function(){
  var sections = document.querySelectorAll('.kp-section[id]');
  var tocLinks = document.querySelectorAll('.kp-toc-list a');
  if(!sections.length || !tocLinks.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        tocLinks.forEach(function(l){l.classList.remove('kp-toc-active')});
        var a = document.querySelector('.kp-toc-list a[href="#'+e.target.id+'"]');
        if(a) a.classList.add('kp-toc-active');
      }
    });
  },{rootMargin:'-20% 0px -70% 0px'});
  sections.forEach(function(s){io.observe(s)});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-policy-privacy"] && !Shopify.designMode) return;
  try {
    

(function(){
  var sections = document.querySelectorAll('.kp-section[id]');
  var tocLinks = document.querySelectorAll('.kp-toc-list a');
  if(!sections.length || !tocLinks.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        tocLinks.forEach(function(l){l.classList.remove('kp-toc-active')});
        var a = document.querySelector('.kp-toc-list a[href="#'+e.target.id+'"]');
        if(a) a.classList.add('kp-toc-active');
      }
    });
  },{rootMargin:'-20% 0px -70% 0px'});
  sections.forEach(function(s){io.observe(s)});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-policy-refund"] && !Shopify.designMode) return;
  try {
    

(function(){
  var sections = document.querySelectorAll('.kp-section[id]');
  var tocLinks = document.querySelectorAll('.kp-toc-list a');
  if(!sections.length || !tocLinks.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        tocLinks.forEach(function(l){l.classList.remove('kp-toc-active')});
        var a = document.querySelector('.kp-toc-list a[href="#'+e.target.id+'"]');
        if(a) a.classList.add('kp-toc-active');
      }
    });
  },{rootMargin:'-20% 0px -70% 0px'});
  sections.forEach(function(s){io.observe(s)});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-policy-subscription"] && !Shopify.designMode) return;
  try {
    

(function(){
  var sections = document.querySelectorAll('.kp-section[id]');
  var tocLinks = document.querySelectorAll('.kp-toc-list a');
  if(!sections.length || !tocLinks.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        tocLinks.forEach(function(l){l.classList.remove('kp-toc-active')});
        var a = document.querySelector('.kp-toc-list a[href="#'+e.target.id+'"]');
        if(a) a.classList.add('kp-toc-active');
      }
    });
  },{rootMargin:'-20% 0px -70% 0px'});
  sections.forEach(function(s){io.observe(s)});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-policy-terms"] && !Shopify.designMode) return;
  try {
    

(function(){
  var sections = document.querySelectorAll('.kp-section[id]');
  var tocLinks = document.querySelectorAll('.kp-toc-list a');
  if(!sections.length || !tocLinks.length) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        tocLinks.forEach(function(l){l.classList.remove('kp-toc-active')});
        var a = document.querySelector('.kp-toc-list a[href="#'+e.target.id+'"]');
        if(a) a.classList.add('kp-toc-active');
      }
    });
  },{rootMargin:'-20% 0px -70% 0px'});
  sections.forEach(function(s){io.observe(s)});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kova-science-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* ── Reference library filter ── */
  var filterBtns = document.querySelectorAll('.kova-ref-filter');
  var refRows = document.querySelectorAll('.kova-ref-row');
  if (filterBtns.length && refRows.length) {
    filterBtns.forEach(function(btn){
      btn.addEventListener('click', function(){
        filterBtns.forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        var filter = btn.getAttribute('data-filter');
        refRows.forEach(function(row){
          if(filter === 'all' || row.getAttribute('data-category') === filter){
            row.classList.remove('hidden');
          } else {
            row.classList.add('hidden');
          }
        });
      });
    });
  }

  /* ── Ingredient row expand/collapse ── */
  var ingRows = document.querySelectorAll('.kova-ing-row');
  ingRows.forEach(function(row){
    var expandable = row.querySelector('.kova-ing-expand');
    if (expandable) {
      row.style.cursor = 'pointer';
      row.addEventListener('click', function(){
        var isOpen = expandable.style.display === 'block';
        // Close all other rows first
        ingRows.forEach(function(r){
          var e = r.querySelector('.kova-ing-expand');
          if (e) e.style.display = 'none';
        });
        expandable.style.display = isOpen ? 'none' : 'block';
      });
    }
  });

  /* ══════════════════════════════════════════════════════════════
     REVEAL-ON-SCROLL — IntersectionObserver w/ premium easing
     Matches homepage animation system for brand consistency
     ══════════════════════════════════════════════════════════════ */
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Ease-out-expo for custom animations (matches CSS --ease-out-expo) */
  function easeOutExpo(t){return t === 1 ? 1 : 1 - Math.pow(2, -10 * t);}

  /* Counter animation for hero stats (500+, 91%, 9%) */
  function animateCounter(el){
    if (el.dataset.counted === 'true') return;
    el.dataset.counted = 'true';
    var target = parseFloat(el.getAttribute('data-count-to'));
    if (isNaN(target)) return;
    var suffix = el.getAttribute('data-count-suffix') || '';
    var duration = parseInt(el.getAttribute('data-count-duration') || '1400', 10);
    var start = performance.now();
    function tick(now){
      var p = Math.min((now - start) / duration, 1);
      var v = Math.round(target * easeOutExpo(p));
      el.textContent = v + suffix;
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = target + suffix;
    }
    requestAnimationFrame(tick);
  }

  function initReveal(){
    if (!('IntersectionObserver' in window) || prefersReducedMotion){
      /* Fallback: show everything immediately */
      document.querySelectorAll('.kova-page-section [data-reveal], .kova-page-section .kova-myth-grid, .kova-page-section .kova-myth-quote, .kova-page-section .kova-atp-step, .kova-page-section .kova-atp-arrow, .kova-page-section .kova-ing-card, .kova-page-section .kova-test-step, .kova-page-section .kova-batch-stat, .kova-page-section .kova-adv-card, .kova-page-section .kova-coa, .kova-page-section .kova-test-tl, .kova-page-section .kova-fcta-box, .kova-page-section .kova-ref-row').forEach(function(el){ el.classList.add('in'); });
      document.querySelectorAll('.kova-page-section [data-count-to]').forEach(function(el){
        var target = parseFloat(el.getAttribute('data-count-to'));
        var suffix = el.getAttribute('data-count-suffix') || '';
        el.textContent = target + suffix;
      });
      /* Progress bars */
      document.querySelectorAll('.kova-page-section .kova-progress-fill[data-fill="men"]').forEach(function(el){ el.classList.add('in-men'); });
      document.querySelectorAll('.kova-page-section .kova-progress-fill[data-fill="women"]').forEach(function(el){ el.classList.add('in-women'); });
      return;
    }

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add('in');

        /* Trigger counter animations inside this revealed element */
        el.querySelectorAll('[data-count-to]').forEach(animateCounter);

        /* Trigger progress bar fills if present */
        el.querySelectorAll('.kova-progress-fill[data-fill="men"]').forEach(function(b){ b.classList.add('in-men'); });
        el.querySelectorAll('.kova-progress-fill[data-fill="women"]').forEach(function(b){ b.classList.add('in-women'); });

        io.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    /* Observe everything that should reveal */
    var targets = document.querySelectorAll(
      '.kova-page-section [data-reveal],' +
      '.kova-page-section .kova-myth-grid,' +
      '.kova-page-section .kova-myth-quote,' +
      '.kova-page-section .kova-atp-step,' +
      '.kova-page-section .kova-atp-arrow,' +
      '.kova-page-section .kova-ing-card,' +
      '.kova-page-section .kova-test-step,' +
      '.kova-page-section .kova-test-tl,' +
      '.kova-page-section .kova-batch-stat,' +
      '.kova-page-section .kova-adv-card,' +
      '.kova-page-section .kova-coa,' +
      '.kova-page-section .kova-fcta-box,' +
      '.kova-page-section .kova-ref-row'
    );
    targets.forEach(function(el){ io.observe(el); });
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
